import { styled, ToggleButton } from '@mui/material';

export const StyledFittingToggleButton = styled(ToggleButton)<{ selected?: boolean }>(
  ({ theme, selected }) => ({
    textTransform: 'none',
    justifyContent: 'flex-start',
    border: '1px solid rgba(0, 0, 0, 0.23) !important',
    width: '100%',
    backgroundColor: 'transparent',
    color: selected ? '#fff' : '#000',
    '&.MuiToggleButtonGroup-firstButton': {
      borderBottomLeftRadius: '8px',
    },
    '&.MuiToggleButtonGroup-lastButton': {
      borderTopRightRadius: '8px',
    },
    '&:hover': {
      backgroundColor: '#14CEC614',
    },
    '&.Mui-selected': {
      display: 'block',
      border: 'none !important',
      color: `${theme.palette.secondary.contrastText} !important`,
      '& .MuiTypography-body2': {
        color: `${theme.palette.secondary.contrastText} !important`,
      },
      '& .MuiTypography-h6': {
        color: `${theme.palette.secondary.contrastText} !important`,
      },
    },
  }),
);
